import React, { useState, useEffect } from 'react'
import { Panel, Button, Input, ControlLabel, Message, Radio, RadioGroup, Col } from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { saveContractSubmit } from '../../redux/actions/contract'
import pathname from '../../constants/pathname'

export default function SubmitContractWidget(props) {
  const { schema } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleCallService = async () => {
    // let request = {
    //   //projectVersionId: projectId,
    //   userId: '',
    //   //value: memo,
    // }
    // console.log('request', JSON.stringify(request))
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await saveContractSubmit(projectId)
      console.log('response', response)

      if (response.model.isSuccess) {
        setShowConfirm(false)
        setIsError(false)
        doneLoading()
        setIsLoading(false)
        sessionStorage.setItem('projectId', response.model.projectVersionId)
        sessionStorage.setItem('param', '')

        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setShowConfirm(false)
        setIsError(true)
      }

      setShowConfirm(false)
    } catch (e) {
      setShowConfirm(false)
      console.log(e.response?.data)
      if (!e?.response?.data?.success) {
        setIsError(e?.response?.data?.errorMessage)
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // setMemo(data.note)
    // if (data.approveType) {
    //   setApproveType(data.approveType)
    // }
    setShowConfirm(true)
  }

  return (
    <div>
      <Panel
        header={schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 10 }}
      >
        {schema?.warningMessage && (
          <Message showIcon type="warning" description={schema.warningMessage} />
        )}

        {isError && <Message showIcon type="error" description={isError} />}

        <br />

        <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
          <Button
            style={{ width: 'auto' }}
            // appearance="ghost"
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={handleSubmit(onSubmit)}
          >
            {schema?.buttonText}
          </Button>
        </Col>
      </Panel>

      <br />

      <ConfirmWidget
        title={`ยืนยัน${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยัน${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
